import { Site } from '@datadog/browser-core';
import versionJson from 'src/version.json';

export const isProduction = process.env.REACT_APP_PROJECT_ID === 'gooduncles-10f09';

export const isLocal = process.env.NODE_ENV === 'development';

export const version = isProduction ? versionJson.prod : versionJson.dev;

export const logArt = `개발자 여러분, 오늘도 고생이 많으십니다.
🥙🥘🍚🍖🥩🍕🍣🍝🥟🍜🍔🍙🍲
`;
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

export const algoliaConfig = {
  applicationId: process.env.REACT_APP_ALGOLIA_APPLICATION_ID,
  searchApiKey: process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY,
};

export const datadogConfig = {
  applicationId: process.env.REACT_APP_DATADOG_APPLICATIONID,
  clientToken: process.env.REACT_APP_DATADOG_CLIENTTOKEN,
  site: process.env.REACT_APP_DATADOG_SITE as Site,
  service: process.env.REACT_APP_DATADOG_SERVICE,
  env: process.env.REACT_APP_PROJECT_ID === 'gooduncles-10f09' ? 'production' : 'development',
};

export const metaConfig = {
  pixelId: process.env.REACT_APP_META_PIXEL_ID,
};
